import { useTranslation } from 'react-i18next';

const certIcons = ['ri-award-fill', 'ri-shield-check-fill', 'ri-government-fill'];

export default function AboutSection() {
  const { t } = useTranslation();

  const certs = [
    { icon: certIcons[0], labelKey: 'about_cert0_label', subKey: 'about_cert0_sub' },
    { icon: certIcons[1], labelKey: 'about_cert1_label', subKey: 'about_cert1_sub' },
    { icon: certIcons[2], labelKey: 'about_cert2_label', subKey: 'about_cert2_sub' },
  ];

  return (
    <section id="about" className="w-full bg-[#F8F7F4] py-16 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center">
          {/* Left Image */}
          <div className="relative">
            <div className="w-full rounded-2xl overflow-hidden">
              <img
                src="/images/about.jpeg"
                alt={t('about_img_alt')}
                className="w-full h-auto object-contain"
              />
            </div>
          </div>

          {/* Right Content */}
          <div>
            <div className="text-[#E8762B] text-xs font-semibold tracking-widest mb-4">{t('about_section_label')}</div>
            <h2 className="text-3xl md:text-4xl font-black text-[#1C2E4A] leading-tight mb-6" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              {t('about_title_line1')}<br />
              <span className="text-[#E8762B]">{t('about_title_highlight')}</span>{t('about_title_line2')}
            </h2>
            <p className="text-[#4A5568] text-sm md:text-base leading-relaxed mb-4">
              {t('about_para1')}
            </p>
            <p className="text-[#4A5568] text-sm md:text-base leading-relaxed mb-4">
              {t('about_para2')}
            </p>
            <p className="text-[#4A5568] text-sm md:text-base leading-relaxed mb-8 md:mb-10">
              {t('about_para3')}
            </p>

            {/* Certs */}
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {certs.map((cert) => (
                <div key={cert.labelKey} className="flex items-center gap-3 bg-white rounded-xl p-3 md:p-4 border border-gray-100">
                  <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-[#F0F4FA] rounded-lg shrink-0">
                    <i className={`${cert.icon} text-base md:text-lg text-[#1C2E4A]`}></i>
                  </div>
                  <div>
                    <div className="text-xs md:text-sm font-bold text-[#1C2E4A]">{t(cert.labelKey)}</div>
                    <div className="text-xs text-gray-400">{t(cert.subKey)}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
